import React, { useEffect, useState } from "react";
import "../../css/style.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/API_Client";
import {
  Alert,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ForgotPassword from "./forgotPassword";
import "../analytics/analytics.css";
import ForgotPasswordOTP from "./forgotPasswordOTP";
import ResetAndChangePassword from "./ResetAndChangePassword";
import CustomButton from "../../reusableComponents/CustomButton";
import { emailRegex } from "../../reusableComponents/constants";
import { colorBrandObject } from "../../../constants/brandings";
import LoadingLogoPage from "../loadingPage/loadingPage";

const BoxPayLogin = () => {
  const {
    login,
    merchantSettings,
    getAllReportType,
    getAllPspConfigs,
    defaultPageLink,
    getAllSetupConfigs,
  } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState();
  const [signInError, setSignInError] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [newMerchant, setNewMerchant] = useState(false);
  const [emailValid, setEmailValid] = useState(true);
  const [mobileLayout, setMobileLayout] = useState(false);
  const [showImagePanel, setShowImagePanel] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [passwordExpired, setPasswordExpired] = useState(false);
  const [show2FA, setShow2FA] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [selectedEnv, setSelectedEnv] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [blockedMinutes, setBlockedMinutes] = useState("")
  const [showAlert, setShowAlert] = useState(false);

  const prodDnsPrefix = "merchant";
  const sandboxDnsPrefix = "sandbox-merchant";
  const queryParams = new URLSearchParams(window.location.search);
  const emailParam = queryParams.get("email");


  const handle2Fa = () => {

    setShow2FA((prev) => !prev);
  };

  const apiCallPostLogin = () => {
    merchantSettings(() => {
      const landingPage = defaultPageLink();
      if (landingPage === undefined) {
        window.location.href = "/";
      } else {
        navigate(landingPage);
      }
    }, setErrorMsg);
    getAllReportType();
    getAllPspConfigs();
  };

  const setErrorMsg = (errMsg) => {
    setSignInError(errMsg);
    handleServerError(errMsg?.response?.data?.message);
    setShowAlert(
      errMsg?.response?.status === 401 ||
      errMsg?.response?.status === 500 ||
      errMsg?.response?.status === 403
    );
  };

  const signInSubmit = async (event) => {
    setLoading(true);
    if (event) {
      event.preventDefault();
    }
    setShowErrors(true);

    if (!emailRegex.test(email)) {
      setEmailValid(false);
      setErrorMsg("Please provide a valid email address");
      return;
    } else {
      setEmailValid(true);
    }

    setTimeout(() => {
      setShowAlert(false);
      setSignInError("");
    });

    if (email === "" || password === "") {
      setErrorMsg("Please provide your login details to continue");
      return;
    }

    setErrorMsg("");
    login(
      email,
      password,
      (userData) => {

        if (userData?.user?.requiresPwdChange) {
          setPasswordExpired(true);
        } else if (!userData?.token) {
          handle2Fa();
        } else {
          // apiCallPostLogin();
        }
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        setErrorMsg(err);
      }
    );
  };
  const handleChange = (event, value) => {
    if (value === "merchant") {
      window.location.href = `https://${value}.boxpay.in`;
    } else {
      window.location.href = `https://${value}.boxpay.tech`;
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    if (event) {
      event.preventDefault();
    }
  };

  const handleForgotChange = () => {
    setShowForgot(true);
  };

  const handleBackToLogin = () => {
    setShowForgot(false);
  };


  const location = useLocation()

  const loginHeader = () => {
    return (
      <div className="login-header">
        <div className="header-boxpay-logo">
          <a href="" className="header-boxpay-logo">
            <img
              src={'/assets/boxpayLogo.svg'}
              alt="BoxPay"
              style={{ width: "100%", height: "100%" }}
            />
          </a>
        </div>
        <div>
          <Tabs
            value={selectedEnv}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            <Tab
              id="simple-tab-0"
              value={prodDnsPrefix}
              label={"Production"}
              style={{
                color: `${colorBrandObject.primaryButtonColor}`,
                fontFamily: "Poppins",
                textTransform: "none",
                fontSize: "14px",
                borderBottom:
                  selectedEnv === prodDnsPrefix ? "2px solid #403E9F" : "none",
              }}
            />
            <Tab
              id="simple-tab-1"
              value={sandboxDnsPrefix}
              label={"Sandbox"}
              style={{
                color: `${colorBrandObject.primaryButtonColor}`,
                fontFamily: "Poppins",
                textTransform: "none",
                fontSize: "14px",
                borderBottom:
                  selectedEnv === sandboxDnsPrefix
                    ? "2px solid #403E9F"
                    : "none",
              }}
            />
          </Tabs>
        </div>
      </div>
    );
  };

  const handleServerError = (message) => {
    if (!message) return;
    const match = message.match(/(\d+)\s*min/); // Extract minutes from message
    if (match?.length) {
      setBlockedMinutes(match[0])
      setIsDisabled(true)
    }
  };

  useEffect(() => {
    if (emailParam) {
      setNewMerchant(true);
    }
  }, []);

  useEffect(() => {
    setSelectedEnv(window.location.hostname.split(".")[0]);
  }, []);

  useEffect(() => {
    if (selectedEnv) {
      getAllSetupConfigs(
        selectedEnv,
        function (data) {
          setPageLoading(false);
          const dashboardTheme = data?.dashboardTheme;
          if (dashboardTheme) {
            localStorage.setItem("brandColors", JSON.stringify(dashboardTheme));
            for (let key in dashboardTheme) {
              if (colorBrandObject.hasOwnProperty(key) && dashboardTheme[key]) {
                colorBrandObject[key] = dashboardTheme[key];
              }
            }
          } else {
            localStorage.setItem(
              "brandColors",
              JSON.stringify(colorBrandObject)
            );
          }
        },
        function (errMsg) {
          setPageLoading(false);
        }
      );
    }
  }, [selectedEnv]);

  return (
    <>
      {pageLoading ? (
        <LoadingLogoPage />
      ) : (
        <div className="login-root">
          {mobileLayout && loginHeader()}
          {showImagePanel === false && mobileLayout === true ? (
            <></>
          ) : (
            <div
              className="login-img-panel"
              style={{
                backgroundColor:
                  colorBrandObject?.loginPageImageBackgroundColor,
              }}
            >
              <div className="login-img-container">
                <img
                  src={'/assets/coverimage.svg'}
                  alt="Login Page"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          )}

          <div className="login-content">
            {!mobileLayout && loginHeader()}
            {showForgot === true ? (
              <>
                <div
                  onClick={() => setShowImagePanel(false)}
                  className="login-main-form"
                >
                  <ForgotPassword
                    forgotPasswordEmail={email}
                    onBackToLogin={handleBackToLogin}
                    mobileLayout={mobileLayout}
                  />
                </div>
              </>
            ) : passwordExpired ? (
              <div
                onClick={() => setShowImagePanel(false)}
                className="login-main-form"
              >
                <ResetAndChangePassword
                  id={"change_password"}
                  title={"Change Password"}
                  email={email}
                  mobileLayout={mobileLayout}
                  creating={false}
                />
              </div>
            ) : newMerchant === true ? (
              <div
                onClick={() => setShowImagePanel(false)}
                className="login-main-form"
              >
                <ForgotPasswordOTP
                  title={"Welcome!"}
                  subtitle={
                    "For verification, please enter a unique code sent on your registered email address"
                  }
                  email={emailParam}
                  mobileLayout={mobileLayout}
                  creating={true}
                />
              </div>
            ) : (
              <>
                {!show2FA ? (
                  <div
                    onClick={() => setShowImagePanel(false)}
                    className="login-main-form"
                  >
                    <Typography className="login-main-title1">Login</Typography>
                    <Typography className="login-main-title2">
                      Welcome back! Please enter your details
                    </Typography>
                    <TextField
                      fullWidth
                      sx={{
                        height: mobileLayout ? "40px" : "40px",
                        marginTop: mobileLayout ? "20px" : "48px",
                      }}
                      placeholder="Email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e?.target?.value)
                        setIsDisabled(false)
                        setShowAlert(false);
                      }}
                      error={showErrors && (!email || !emailValid)}
                      autoFocus={true}
                      onKeyDown={(e) => {
                        if (e?.key === "Enter") {
                          signInSubmit(e);
                        }
                      }}
                    />
                    {showErrors && (!email || !emailValid) ? (
                      email ? (
                        <div className="email-error">
                          <img src="/assets/errorOutline.svg" alt="Error" />
                          <Typography
                            className="labelRegularRes"
                            sx={{
                              color: "#EA1238 !important",
                            }}
                          >
                            Please enter a valid email address
                          </Typography>
                        </div>
                      ) : (
                        <div className="email-error">
                          <img src="/assets/errorOutline.svg" alt="Error" />
                          <Typography
                            className="labelRegularRes"
                            sx={{
                              color:
                                "var(--Comms-Negative, #B9232F) !important",
                            }}
                          >
                            Email is required
                          </Typography>
                        </div>
                      )
                    ) : signInError?.response?.status === 404 ? (
                      <div className="email-error">
                        <img src="/assets/errorOutline.svg" alt="Error" />
                        <Typography
                          className="labelRegularRes"
                          sx={{
                            color: "var(--Comms-Negative, #B9232F) !important",
                          }}
                        >
                          Email address doesn’t exist. Please check again and
                          retry
                        </Typography>
                      </div>
                    ) : (
                      <div className="email-error"></div>
                    )}
                    <OutlinedInput
                      sx={{
                        height: mobileLayout
                          ? "40px !important"
                          : "40px important",
                      }}
                      fullWidth
                      id="outlined-adornment-password"
                      placeholder="Password"
                      type={showPassword ? "" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e?.target?.value)}
                      onKeyDown={(e) => {
                        if (e?.key === "Enter") signInSubmit(e);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />

                    <Typography
                      sx={{
                        marginTop: mobileLayout ? "4px" : "6px",
                        fontSize: mobileLayout
                          ? "12px important"
                          : "14px !important",
                        marginBottom: mobileLayout ? "18px" : "46px",
                        cursor: "pointer",
                        color: `${colorBrandObject.primaryButtonColor} !important`,
                      }}
                      className="forgotStyle"
                      onClick={handleForgotChange}
                    >
                      Forgot Password?
                    </Typography>

                    <CustomButton
                      variant={"contained"}
                      width={"100%"}
                      color="primary"
                      size={mobileLayout ? "xxl" : "xxxl"}
                      text={"Login"}
                      onClick={signInSubmit}
                      disabled={!email || !password || isDisabled}
                      loading={loading}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "8px",
                      }}
                    >
                      <Typography
                        style={{
                          color: "rgba(84, 113, 135, 1)",
                          fontWeight: 500,
                          fontSize: mobileLayout ? "12px" : "14px",
                        }}
                      >
                        Don’t have an account?&nbsp;
                      </Typography>
                      <Typography
                        style={{
                          color: "rgba(64, 62, 159, 1)",
                          fontWeight: 500,
                          fontSize: mobileLayout ? "12px" : "14px",
                        }}
                      >
                        <a
                          href="https://www.boxpay.tech/contact-us-form"
                          style={{
                            fontSize: mobileLayout ? "12px" : "14px",
                            // color: "rgba(64, 62, 159, 1)",
                            color: `${colorBrandObject.primaryButtonColor}`,
                          }}
                        >
                          Contact Us
                          {/* Contact BoxPay */}
                        </a>
                      </Typography>
                    </div>

                    <div>
                      {signInError && !isDisabled && (
                        <Alert
                          icon={false}
                          sx={{
                            display: showAlert ? "flex" : "none",
                            alignItems: "center",
                          }}
                          className={` ${signInError?.response?.status === 403
                            ? "alert-red"
                            : "alert"
                            }`}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "4px",
                              justifyContent: "center",
                              alignItems: "flex-start",
                            }}
                          >
                            <img
                              src={
                                signInError?.response?.status === 403
                                  ? "/assets/warningSignRed.svg"
                                  : "/assets/warningSign.svg"
                              }
                              style={{
                                width: mobileLayout ? "12px" : "24px",
                                paddingTop: mobileLayout ? "5px" : "0px",
                              }}
                            />

                            <div
                              style={{
                                marginTop:
                                  signInError?.response?.status === 403
                                    ? ""
                                    : "4px",
                                marginLeft: "4px",
                                fontFamily: "Poppins",
                                fontSize: mobileLayout ? "12px" : "14px",
                                fontWeight: "500",
                              }}
                            >
                              {signInError?.response?.data?.message}
                            </div>
                          </div>
                        </Alert>
                      )}
                      {isDisabled && (
                        <Alert
                          icon={false}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                          className={`alert-red`}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "4px",
                              justifyContent: "center",
                              alignItems: "flex-start",
                            }}
                          >
                            <img
                              src={"/assets/warningSignRed.svg"}
                              style={{
                                width: mobileLayout ? "12px" : "24px",
                                paddingTop: mobileLayout ? "5px" : "0px",
                              }}
                            />

                            <div
                              style={{
                                marginLeft: "4px",
                                fontFamily: "Poppins",
                                fontSize: mobileLayout ? "12px" : "14px",
                                fontWeight: "500",
                              }}
                            >
                              Unique code cannot be sent more than 3 times. Your account is locked for {blockedMinutes}</div>
                          </div>
                        </Alert>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="login-main-form">
                    <div className="back-to-login" onClick={handle2Fa}>
                      <img src="/assets/arrowNarrowLeft.svg" alt="Arrow" />
                      Back to Login
                    </div>
                    <ForgotPasswordOTP
                      title={"Two-Factor Authentication"}
                      subtitle={
                        "For verification, please enter a unique code sent on your registered email address"
                      }
                      email={email}
                      mobileLayout={mobileLayout}
                      creating={false}
                      twoFA={true}
                      apiCallPostLogin={apiCallPostLogin}
                      editBackButton={handle2Fa}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BoxPayLogin;
